import React from "react";
import Navbar from '../Auth/Navbar';

function ContactUs() {
    return (
        <React.Fragment>
            <Navbar />
            <h1 style={{textAlign: 'center'}}>Contact Us</h1>
        </React.Fragment>
    );
}

export default ContactUs;